import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: '뒤로',
      changePassword: '비밀번호 변경',
      copiedVaultId: '복사됨!',
      copyVaultID: 'Vault ID 복사하기',
      create: '생성',
      next: '다음',
      notSure: '잘 모르겠음',
      signUp: '가입하다',
      submit: '제출',
      updatePassword: '비밀번호 업데이트',
    },
    Errors: {
      createReportFailed: '보고서를 생성하지 못했습니다.',
    },
    ReportStatus: {
      CLOSED: '종결됨',
      INVESTIGATING: '조사 중',
      NEW: '제출됨',
      READ: '읽음',
    },
    general: {
      navbar: {
        caseSettings: '케이스 설정',
        changePassword: '비밀번호 변경',
        logOut: '로그 아웃',
        notifications: '알림',
        notificationsDrawer: {
          appFileScanFailed: '파일이 보안 검사에 실패했습니다.',
          appReportMatch: '당신의 GoTogether 기록이 매치되었습니다.',
          appReportReassigned: '새로운 사례 관리자가 배정되었습니다',
          case: '사례',
          caseAssigned: '당신에게 할당된 사례',
          caseImporterJobCompleted: {
            PartialSuccess:
              '당신의 사례 가져오기가 오류와 함께 완료되었습니다.',
            failure: '당신의 케이스 가져오기가 실패했습니다.',
            success: '당신의 케이스 가져오기가 성공적으로 완료되었습니다.',
          },
          caseLinked: '연결된 케이스',
          caseTeamInvite: '사건에 추가됨',
          caseUnlinked: '연결 해제된 케이스',
          dataSanitisation: '보고서 세부 정보 업데이트됨',
          emptyDescription: '나중에 새로운 알림을 확인하십시오.',
          emptyTitle: '모든 것을 다 따라잡았습니다',
          importId: '수입 ID:',
          learnMore: '더 알아보기',
          markAllAsRead: '모두 읽음으로 표시',
          newMessage: '새로운 메시지',
          newReport: '새로운 보고서 수신됨',
          permissionRemoved: '사건에서 제외됨',
          postSSubmissionFile: '증거 파일(들)이 추가되었습니다.',
          report: '보고서',
          reportAssigned: '당신에게 할당된 보고서',
          reportStatusChange: '보고서 상태 변경됨',
          reporterAnonymised: '당신의 세부 정보가 익명화되었습니다',
          reporterReportSubmitted: {
            subtitle: '당신의 보고서 복사본을 저장하는 것을 권장합니다',
            title: '제출된 보고서',
          },
          mitigationPlanReminder: '완화 계획 승인이 필요합니다',
          staleCase: '처리되지 않은 케이스',
        },
        privacyStatement: '개인정보 보호 정책',
        reporter: {
          myReports: '내 보고서',
        },
        settings: '설정',
        technicalSupport: '기술 지원',
        title: '계정',
      },
      time: {
        day: '날',
        days: '일수',
        hour: '시간',
        hours: '시간',
        minute: '분',
        minutes: '분',
        second: '두 번째',
        seconds: '초',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: '익명',
        autoTranslate: '자동 번역은 기본적으로 꺼져 있습니다.',
        backToMessages: '메시지로 돌아가기',
        caseSettings: '케이스 설정.',
        changeInProfile:
          '이 설정을 변경하길 원하신다면, 당신의 프로필에서 할 수 있습니다.',
        deletedByMessage: '{{author}} 에 의해 삭제됨',
        deletedMessageLabel: '이 메시지는 삭제되었습니다',
        description:
          '자동 번역이 켜져 있을 때, 모든 보고서 메시지는 기본 언어로 선택된 브라우저를 기반으로 AI가 자동으로 번역합니다.',
        descriptionSecondHalf:
          '모든 메시지의 원본 버전은 항상 보존되며, 채팅에서 찾을 수 있습니다.',
        messagePlaceholder: '타이핑을 시작하세요...',
        messageSettings: '메시지 설정.',
        originalMessages: '원본',
        showMoreBanner: '자동 번역에 대해 더 자세히 알아보기',
        titlev2: '선호하는 언어로 모든 메시지를 읽으세요.',
        translatedMessageLabel: '번역된 메시지',
        translatedMessages: '번역된',
        understood: '이해했습니다',
      },
      Country: {
        description: '어느 나라에서 근무하고 계십니까?',
        header: '어느 나라에서 근무하고 계십니까?',
        noOptions: '국가를 찾을 수 없습니다',
        other: '기타',
        placeholder: '국가 검색...',
      },
      CreatePublicReport: {
        createReport: '새 보고서 생성',
        helpPage: '우리의 도움말 페이지로 가세요',
        loginToOpr: '보고서 추적을 위해 로그인하세요',
        or: '또는',
        passwordPlaceholder: '비밀번호 입력',
        phoneNumberLoginFailed:
          '로그인 실패, 전화번호/핀 번호가 잘못되었습니다',
        phoneNumberPlaceholder: '전화번호를 입력하세요',
        phoneNumberTooltip:
          'VaultTalk에 연락하기 위해 사용한 전화번호를 입력하세요.',
        pinPlaceholder: '핀 입력',
        reportIntroductionParagraph1:
          '사건을 보고할 때, 당신의 경험을 문서화하는 데 도움이 될 몇 가지 질문을 받게 될 것입니다.',
        reportIntroductionParagraph2:
          '제출하기 전에, 개인정보 보호를 위해 익명으로 남을 옵션이 있습니다.',
        reportIntroductionParagraph3:
          '제출한 후에는 언제든지 로그인하여 보고서의 진행 상황을 확인하고 케이스 매니저와 대화할 수 있습니다.',
        reportIssue: '문제 신고',
        usernameLoginFailed:
          '로그인 실패, 사용자 이름/비밀번호가 잘못되었습니다',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired: '회사와의 관계가 필요합니다',
            reportedCategoryRequired: '보고된 카테고리가 필요합니다',
          },
        },
        vaultId: 'Vault ID',
        vaultIdPlaceholder: '이메일 또는 Vault ID를 입력하세요.',
        vaultIdTooltip:
          '익명 보고서의 경우 Vault ID는 알파벳과 숫자를 조합한 것입니다. 보고서가 익명이 아닌 경우, Vault ID는 귀하의 이메일 주소입니다.',
        vaultTalk: 'VaultTalk',
        yourPassword: '당신의 비밀번호',
        yourPhoneNumber: '당신의 전화 번호',
        yourPin: '당신의 6자리 핀 번호',
        yourVaultId: '당신의 Vault ID',
      },
      CustomHeader: {
        companyLogo: '회사 로고',
        openReporting: '보고 열기',
        userSettings: '사용자 설정',
      },
      Date: {
        approximateDescription: '사건이 발생한 대략적인 날짜를 기억하십니까?',
        approximatePlaceholder: '예: 6개월 전 / 작년 / 작년 11월',
        cancel: '취소',
        clear: '지우기',
        description: '사건이 발생한 날짜를 기억하십니까?',
        header: '사건은 무슨 요일에 일어났습니까?',
        ok: '확인',
        placeholder: '예: 2020년 6월 21일',
      },
      Description: {
        whatHappened: '무슨 일이 있었습니까?',
        whatHappenedPlaceholder: '직접 설명해 주십시오...',
        whatHappenedText: '무슨 일이 있었는지 직접 설명해 주십시오.',
      },
      Details: {
        disclaimer:
          '이 세부사항들은 보고서와 함께 공개될 것입니다. 익명을 유지하고 싶다면, 신원을 확인할 수 있는 정보가 포함되어 있지 않도록 확인하십시오.',
        emailPlaceholder: '이메일(선택사항)',
        fullNamePlaceholder: '성명(선택사항)',
        header: '귀하의 세부 정보',
        nonAnonSubtitle:
          '당신의 이름 또는 이메일 주소를 제공해주세요. 이 보고서에 대한 알림을 받고 싶다면, 아래에 적절한 이메일 주소를 추가해주세요.',
        nonOptionalEmailPlaceholder: '이메일',
        nonOptionalFullNamePlaceholder: '전체 이름',
        subtitle:
          '이 보고서에 대한 알림을 받고 싶다면, 아래에 적절한 이메일 주소를 추가하십시오.',
      },
      Emotion: {
        description: '기분이 어땠습니까? 어떤 영향을 미쳤습니까?',
        header: '어떤 영향을 미쳤습니까?',
        placeholder: '입력 시작...',
      },
      Evidence: {
        addedHeading: '추가됨',
        deletedMessage: '삭제되었습니다',
        deletedStatus: '삭제됨',
        failedToOpenFileMessage: '파일을 열지 못했습니다. 다시 시도해 주세요.',
        fileStatuses: {
          infectedUpload: '보안 검사에 의해 플래그됨',
          passedUpload: '보안 검사 통과',
          pendingUpload: '진행 중인 보안 검사',
          readyForDownload: '다운로드 준비 완료',
        },
        mobileErrorMessage:
          '플래그된 파일: 당신의 사례 관리자에게 메시지를 보내십시오.',
        nameHeading: '이름',
        statusHeading: '상태',
        tableTitle: '증거',
        webErrorMessage:
          '플래그된 파일: 파일이 플래그된 경우, 케이스 매니저에게 메시지를 보내 주십시오.',
      },
      FileUpload: {
        addFiles: '파일 추가',
        addMoreFiles: '더 많은 파일을 추가하세요',
        confirm: '확인',
        description:
          '증거로 파일을 추가하면 담당자가 문제를 효율적으로 해결하는데 도움이 될 수 있습니다. 익명을 유지하려는 경우 파일 내용 (파일 메타데이터 포함)을 고려하고, 다른 개인의 권리와 적용 가능한 법률을 존중해주십시오.',
        dragDrop: '여기에 파일을 끌어 놓거나',
        errorMessage:
          '파일이 네트워크 오류로 실패했습니다. 아래를 클릭하여 사례 관리자에게 도움을 요청하십시오.',
        fileLimit: '각 파일 크기 제한: 100MB',
        fileUploadLimitText: '당신은 오직 10개의 파일만 업로드 할 수 있습니다.',
        header: '증거를 추가하십시오',
        helpArticle: '도움말 기사',
        highlighted: '파일 검색',
        information: '지원되는 파일 타입',
        moreInformation: '자세한 정보는 이것을 참조하십시오 <a>도움말 기사</a>',
        postSubmissionErrorMessage:
          "시스템 오류로 인해 파일을 업로드 할 수 없었습니다. '확인'을 다시 선택해 주세요.",
        tooltipAudio: '오디오:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: '문서:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: '이미지:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: '텍스트:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: '비디오:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: '파일이 너무 큽니다',
          invalidFileType: '지원되지 않는 파일 유형: {{extension}}',
          systemError: '시스템 에러',
          tooManyFiles: '파일의 최대 수는 {{maxFiles}}입니다',
        },
        uploadFiles: '파일 업로드',
      },
      Loading: {
        loading:
          '우리가 당신의 보고서를 케이스 매니저에게 제출하는 동안 기다려 주십시오...',
        postSubmissionLoading: '당신의 파일을 제출하는 동안 기다려 주십시오...',
      },
      Location: {
        description: '사건은 어디에서 일어났습니까?',
        header: '사건은 어디에서 일어났습니까?',
        placeholder: '예: 사무실에서',
      },
      MessageListBox: {
        messageCaseManager: '사례 관리자에게 메시지 보내기',
        report: '{{displayReportId}} {{submissionType}} 보고',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: '번역 비활성화',
        enableTranslationLabelEnabled: '번역 가능',
        enableTranslationsDescription:
          '자동 번역을 활성화하고 선호하는 언어로 모든 보고서 메시지를 읽으십시오. 번역된 언어는 기기에서 선택한 언어를 기준으로 합니다.',
        enableTranslationsHeader: '보고서 메시지에 대한 자동 번역 활성화',
        enableTranslationsSubDescriptionv2:
          '각 채팅에서 번역된 언어와 원래의 언어를 전환할 수 있습니다.',
        updateTranslationFailed: '번역 업데이트 실패',
        updateTranslationSuccess: '번역 설정이 성공적으로 업데이트되었습니다.',
      },
      Password: {
        changePasswordHeader: '비밀번호 변경',
        createNewPassword: '새 비밀번호를 생성하십시오.',
        createPasswordHeader: '귀하의 비밀번호',
        currentPasswordPlaceholder: '현재 비밀번호 입력',
        description:
          '유효한 비밀번호는 최소 9자 이상이어야 하며, 대문자 1개와 숫자 1개가 포함되어야 합니다.',
        enterCurrentPassword: '현재 비밀번호를 입력하십시오.',
        forgottenPasswordInstructions:
          'Vault ID(이메일 주소가 아닌)를 알파벳과 숫자로 입력하고 이메일 주소를 입력하여 비밀번호를 재설정하십시오.',
        newDescription:
          '계정의 보안을 유지하기 위해 강력한 비밀번호를 생성하세요. 아래의 가이드라인을 보려면 타이핑을 시작하세요.',
        passwordPlaceholder: '비밀번호 생성',
        passwordResetRequestedDescription:
          '당신의 Vault ID가 우리 시스템에 존재한다면, 비밀번호를 재설정하는 방법에 대한 이메일을 받게 될 것입니다.',
        passwordResetRequestedHeader: '비밀번호 재설정 링크 요청됨',
        reenterPlaceholder: '비밀번호를 다시 입력하십시오.',
        subtitle:
          '이 보고서를 제출하고 나중에액세스하려면 비밀번호를 생성하십시오.',
        yourVaultId: '당신의 Vault ID',
        yourVaultIdPlaceholder: 'Vault ID를 입력하세요 (예. {{exampleId}})',
      },
      Perpetrators: {
        description:
          '특정한 한 사람을 신고하는 것입니까 아니면 여러 사람을 신고하는 것입니까? 그 사람의 이름을 밝히거나 묘사해 주시겠습니까?',
        header: '참여한 사람들',
        placeholder:
          '입력을 시작하고, 쉼표를 사용하여 여러 사람의 이름이나 설명을 추가하십시오.',
      },
      PoweredByVault: '{{company}} 제공',
      PrivacyStatement: '제품 개인정보 보호 선언문',
      PublicMessageList: {
        myMessages: '내 메시지',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: '기존 보고서에 추가된 증거',
        backToReportId: '보고서 ID로 돌아가기: {{reportId}}',
        description:
          '증거로 파일을 추가하는 것은 당신의 사건 관리자가 결정을 내리는 효율성을 지원하는 데 도움이 될 수 있습니다. 익명을 원한다면 파일 내용(파일 메타데이터 포함)을 고려해 주시고, 다른 개인의 권리와 적용 가능한 법률을 존중해 주십시오. 자세한 정보는 다음을 참조하십시오. <a>도움말 기사</a>',
        header: '보고서에 추가 증거를 첨부하십시오',
        vaultTalkOpenCaseHeader: '당신의 보고서에 증거를 추가하십시오',
      },
      PublicReport: {
        anonymous: '익명',
        backToReports: '보고서로 돌아가기',
        skipped: '건너뜀',
      },
      PublicReportCard: {
        addEvidence: '추가 증거를 제공하십시오',
        messageCaseManager: '사례 관리자에게 메시지 보내기',
        reportId: '보고서 ID:',
        submitted: '제출됨',
        vaultTalkClosedCaseCTA: '증거 보기',
        vaultTalkOpenCaseCTA: '증거 추가',
        viewAdditionalEvidence: '추가 증거를 확인하십시오.',
        viewReport: '보고서 보기',
      },
      PublicReportsList: {
        reportingSystem: '보고 시스템',
      },
      Question: {
        placeholder: '타이핑을 시작하세요...',
        question: '세부사항 제공',
        questionText:
          '우리와 당신의 걱정, 업데이트, 또는 문의사항을 공유해 주세요.',
      },
      Relationship: {
        header: '귀하와 조직의 관계',
        tellUsAbout: '귀하와 조직의 관계에 대해 말씀해 주십시오.',
      },
      ResponsiveNavMenu: {
        messages: '내 메시지들',
        reports: '내 보고서들',
      },
      Site: {
        description: '어느 사업장에서 근무하고 계십니까?',
        header: '어느 사업장에서 근무하고 계십니까?',
        noOptions: '사업장을 찾을 수 없습니다',
        other: '기타',
        placeholder: '사업장 검색...',
      },
      SpamPuzzle: {
        dialog: '계속하려면 이 퍼즐을 푸십시오.',
      },
      SubmissionTypes: {
        reportIssue: '카테고리 선택',
        whatType: '보고서를 가장 잘 설명하는 카테고리를 선택하세요',
      },
      SubmitSuccess: {
        category: '<bold>카테고리:</bold> {{category}}',
        country: '<bold>국가:</bold> {{country}}',
        dateSubmitted: '<bold>제출 날짜:</bold> {{date}}',
        recordYourVaultID: '이 정보를 로그인에 사용하기 위해 기억하세요',
        successInformation: '더 많은 정보',
        successMessage:
          '귀하의 보고서가 제출되었고 검토를 위해 준비되었습니다. 주의가 필요한 첨부 파일은 로그인 시 플래그 표시됩니다. 아래에서 로그인하여 보고서 업데이트를 보고 케이스 매니저에게 메시지를 보내십시오.',
        successSanitationMessage:
          '당신의 기록을 위해 사본을 보관하고, Vault-ID를 안전하게 보관하세요 - 업데이트를 받고 당신의 사례 관리자에게 메시지를 보내는 데 필요합니다.',
        successSanitationTagline:
          '귀하의 보고서가 제출되어 안전하게 보관되었습니다.',
        successThankYou: '당신의 보고서에 감사드립니다!',
        viewReport: '보고서 보기',
      },
      Time: {
        approximateDescription: '사건이 발생한 대략적인 시간을 기억하십니까?',
        approximatePlaceholder: '예: 아침, 오후',
        description: '사건이 일어난 시간을 기억하십니까?',
        header: '사건은 몇 시에 일어났습니까?',
        invalidTime: '시간 형식은 HH:MM이어야 합니다.',
      },
      UserSettingsDialog: {
        changePassword: '비밀번호 변경',
        closeDialog: '대화상자 닫기',
        logout: '로그아웃',
        messageSettings: '메시지 설정',
        userSettings: '사용자 설정',
      },
      Witnesses: {
        description:
          '무슨 일이 있었는지 다른 사람에게 말했거나 다른 사람이 보았습니까?',
        header: '목격자가 있습니까?',
        placeholder: '입력 시작...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: '메시지 보내기',
        title: '메시지 케이스 매니저',
        translationHeader: '자동 번역에 대해 더 알아보기',
      },
      ReportCard: {
        addEvidence: '증거를 추가하십시오',
        submissionModeVia: '{{submissionMode}}를 통해',
        viewEvidence: '증거를 확인하십시오',
      },
      ReportList: {
        yourReports: '당신의 보고서',
      },
      ReportingActivate: {
        buttonText: '계속하다',
        description:
          '당신의 조직이 계정에 등록하였다면, 우리는 설정을 완료할 수 있는 지침이 포함된 이메일을 보내드릴 것입니다.',
        emailInput: '이메일',
        header: '근무 이메일을 입력하십시오',
        successAccount:
          '당신의 조직이 계정에 등록해 두었다면, 설정을 완료하는 방법을 안내하는 이메일을 보내드릴 것입니다.',
        successEmail:
          '당장 보이지 않는다면 몇 분 기다렸다가 이메일 받은편지함을 새로 고치세요.',
        successHeading: '감사합니다',
      },
      ReportingAddEvidence: {
        descriptionHeader: '당신의 보고서에 증거를 추가하십시오',
        descriptionText:
          '사례 관리자의 해결 효율성을 지원하기 위해 파일을 증거로 추가하는 것이 도움이 될 수 있습니다. 익명을 유지하려는 경우 파일 내용(파일 메타데이터 포함)을 고려하시고, 다른 개인의 권리와 적용 가능한 법률을 존중해주십시오. 자세한 정보는 이 <a>도움말 기사</a>를 참조하십시오.',
        emptyMessage: '추가 증거가 업로드되지 않았습니다',
      },
      ReportingChangePassword: {
        back: '뒤로',
        description:
          '계정의 보안을 유지하기 위해 강력한 비밀번호를 생성하세요. 아래의 지침을 보려면 입력을 시작하세요.',
        errorToast: '비밀번호를 만들 수 없습니다, 토큰이 유효하지 않습니다.',
        header: '비밀번호 변경',
        incorrectCurrentPassword:
          '현재 비밀번호가 잘못되었습니다. 확인해보시고 다시 시도해주세요.',
        invalidToken: '잘못된 토큰',
        passwordUpdated: '비밀번호 업데이트됨',
        passwordUpdatedDescription:
          '비밀번호가 성공적으로 업데이트되었습니다. 데이터를 안전하게 보관하기 위해 이 단계를 밟아주셔서 감사합니다!',
        passwordUsedBefore: '비밀번호 재사용은 허용되지 않습니다.',
        passwordUsedBeforeDescription:
          '당신의 안전을 위해, 마지막으로 사용한 6개의 비밀번호는 재사용할 수 없습니다. 계정을 안전하게 유지하기 위해 새롭고 고유한 비밀번호를 선택하고 다시 시도해주세요.',
        toastDescription:
          '당신의 비밀번호가 성공적으로 업데이트되었습니다. 데이터를 안전하게 유지하기 위해 이 단계를 밟아 주셔서 감사합니다!',
        toastMessage: '비밀번호 업데이트됨',
        updatePasswordCTA: '비밀번호 업데이트',
      },
      ReportingConnect: {
        cancelButton: '취소',
        connectButton: '연결',
        disclaimer:
          'Slack 계정을 Vault 계정과 연결하면 안전하고 비공개 연결이 보장됩니다.<br /><br />연결함으로써 Slack 내에서 직접 부적절한 행동을 신고하거나 질문을 할 수 있습니다. 연결 후 항상 익명으로 신고할 옵션이 있습니다. 귀하의 개인 정보 보호와 보안은 우리의 최우선 순위입니다.',
        heading:
          'Vault Platform이 귀하의 {{organisationName}} Slack 계정에 접근하도록 허용을 요청하고 있습니다.',
        listHeading: 'Vault은 무엇을 할 수 있을까요?',
        permissionIdentity: {
          extraInfo: 'Vault는 당신의 Slack 사용자 신원을 볼 수 있을 것입니다.',
          heading: '사용자의 신원에 대한 정보를 확인하십시오',
        },
        permissionNotifications: {
          extraInfo:
            'Vault는 제출된 보고서나 질문에 대한 업데이트나 관련 사항에 대해 Slack 계정으로 알림을 보낼 수 있습니다.',
          heading: '알림을 보냅니다',
        },
        permissionOverview: {
          extraInfo:
            'Vault는 홈페이지에서 모든 제출물의 개요를 표시할 것입니다.',
          heading: '제출물 개요',
        },
        permissionSubmitReport: {
          extraInfo:
            '이것은 Vault에게 보고서를 제출하거나 직접 질문을 하도록 권한을 부여하며, Slack으로부터 귀하의 기관에 바로 접근할 수 있게 해줍니다.',
          heading: '당신을 대신하여 보고서 또는 질문을 제출하십시오',
        },
        successfulConnectionDescription:
          '당신의 Vault 계정과 Slack 계정이 이제 연결되었습니다. 이제 이 탭을 닫고 Slack으로 돌아갈 수 있습니다.',
        successfulConnectionHeading: '성공적으로 연결되었습니다.',
        unsuccessfulConnectionDescription:
          '문제가 발생했습니다. 이 탭을 닫고 Slack으로 돌아가서 다시 시도해 주세요.',
        unsuccessfulConnectionHeading: '연결 실패',
      },
      ReportingForgotPassword: {
        description:
          '계정에 연결된 이메일 주소를 입력하시면, 비밀번호를 재설정할 수 있는 링크를 보내드리겠습니다.',
        heading: '잊어버린 비밀번호',
        invalidTokenError: '비밀번호를 생성할 수 없습니다, 무효한 토큰입니다.',
        passwordReuseError: '비밀번호 재사용 허용되지 않음',
        passwordReuseErrorDescription:
          '당신의 안전을 위해, 마지막 여섯 번의 비밀번호를 재사용할 수 없습니다. 계정을 안전하게 유지하기 위해 새롭고 고유한 비밀번호를 선택하고 다시 시도해 주세요.',
        sendLink: '재설정 링크를 보내주세요',
        sendLinkFailure: '무언가 잘못되었습니다',
        sendLinkFailureDescription:
          '<a>리포터 허브</a>로 돌아가서 다시 시도하십시오. 문제가 계속되면 <mailto>techsupport@vaultplatform.com</mailto>로 연락주십시오.',
        sendLinkSuccess: '비밀번호 재설정 링크가 전송되었습니다',
        sendLinkSuccessDescription:
          '우리는 비밀번호 재설정 링크를 {{email}}로 보냈습니다.',
        updatePasswordSuccess: '비밀번호가 업데이트되었습니다',
        updatePasswordSuccessDescription:
          '비밀번호가 성공적으로 업데이트되었습니다. 데이터를 안전하게 보호하기 위해 이 단계를 밟아주셔서 감사합니다!',
      },
      ReportingLogin: {
        accountFrozen: '계정이 동결되었습니다.',
        accountLocked:
          '로그인이 너무 많이 잘못 시도되었습니다. 계정이 최대 1시간 동안 잠겼습니다. 이 기간 동안 비밀번호 재설정이 불가능합니다.',
        accountLockedPermanently:
          '당신의 계정이 잠겼습니다. 암호를 재설정하여 액세스를 복구하거나 시스템 관리자에게 추가 도움을 요청하세요.',
        createAccountCTA: '계정을 등록하십시오',
        currentPassword: '현재 비밀번호',
        emailLabel: '당신의 이메일',
        forgotPassword: '비밀번호를 잊으셨나요?',
        loginButton: '로그인',
        newPasswordPlaceholder: '새 비밀번호',
        passwordFailMessage:
          'Slack의 Vault 앱으로 돌아가서 다시 시도해 보세요. 문제가 계속되면 techsupport@vaultplatform.com으로 연락해 주세요.',
        passwordFailTitle: '무언가 잘못되었습니다',
        passwordLabel: '당신의 비밀번호',
        passwordPlaceholder: '비밀번호를 입력하세요',
        passwordResetRequired: '비밀번호 재설정 필요',
        passwordSuccessfullySetMessage:
          'Slack의 Vault 앱으로 돌아가서 새 비밀번호로 인증하고 중단된 곳에서 계속하십시오.',
        passwordSuccessfullySetTitle: '비밀번호가 성공적으로 설정되었습니다',
        reenterPlaceholder: '비밀번호를 다시 입력하세요',
        title: '리포터 허브',
        tooltip:
          'Vault 앱에 대한 비밀번호를 아직 설정하지 않았다면, 여기를 따라 시작하세요. 비밀번호를 잊어버렸다면 아래의 "비밀번호를 잊으셨나요" 링크를 사용하세요.',
        usernameLoginFailed:
          '로그인 실패, 사용자 이름 또는 비밀번호가 잘못되었습니다.',
      },
      ReportingReset: {
        failureDescription:
          'Slack의 Vault 앱으로 돌아가서 다시 시도해보십시오. 문제가 계속되면 <mailto>techsupport@vaultplatform.com</mailto> 로 연락해주십시오.',
        failureHeading: '무언가 잘못되었습니다',
        successDescription:
          'Slack의 Vault 앱으로 돌아가서 새 비밀번호로 인증하고 중단된 곳에서 계속하십시오.',
        successHeading: '비밀번호가 성공적으로 설정되었습니다',
      },
      noReports: {
        description:
          '제출된 모든 보고서는 여기에 표시됩니다. 보고서를 제출할 수 있는 방법에 대해 자세히 알아보세요.',
        descriptionHelpArticle: '이 도움말 기사',
        errorDescription:
          '우리는 귀하의 보고서를 불러오는 데 어려움을 겪고 있습니다. 페이지를 새로고침 해보십시오.',
        errorDescriptionSecondary:
          '그것이 작동하지 않는다면, 저희에게 연락해 주세요.',
        errorTitle: '⚠️ 이런, 뭔가 잘못되었네요',
        title: '아직 보고서가 없습니다',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            '자동 번역을 활성화하고 선호하는 언어로 모든 보고서 메시지를 읽으십시오. 번역된 언어는 장치에서 선택한 언어를 기반으로 합니다.',
          autoTranslationDescription2:
            '각 채팅에서 번역된 언어와 원래 언어를 전환할 수 있습니다.',
          autoTranslationTitle: '보고서 메시지에 대한 자동 번역 활성화',
          header: '메시지 설정',
          subHeader: '메시지가 표시되는 방식 구성하기',
        },
        notificationSettings: {
          emailDescription:
            '보고서에 중요한 업데이트가 있을 때 이메일 알림을 받으십시오',
          emailTitle: '이메일 알림',
          header: '알림 설정',
          subHeader: '알림을 받는 방식을 설정하세요',
        },
        title: '설정',
        updatedSettingsFailure: '설정 업데이트에 실패했습니다.',
        updatedSettingsSuccess: '성공적으로 설정을 업데이트했습니다.',
      },
    },
    validators: {
      passwordLength: '비밀번호는 9자 이상이어야 합니다.',
      passwordLowercase: '비밀번호에는 소문자가 1개 이상 포함되어야 합니다.',
      passwordMissMatch: '비밀번호와 확인 필드는 일치해야 합니다.',
      passwordNumeric: '비밀번호에는 숫자가 1개 이상 포함되어야 합니다.',
      passwordUppercase: '비밀번호에는 대문자가 1개 이상 포함되어야 합니다.',
    },
    validatorsNew: {
      passwordLength: '10에서 30개의 문자 사이',
      passwordLowercase: '적어도 하나의 소문자',
      passwordMissMatch: '비밀번호가 일치하지 않습니다.',
      passwordNumeric: '적어도 하나의 숫자',
      passwordSpecialCharacter: '적어도 하나의 특수 문자',
      passwordUppercase: '적어도 하나의 대문자',
    },
  },
};

export default translations;
